/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateAttachmentDto } from './CreateUpdateAttachmentDto';
import {
    CreateUpdateAttachmentDtoFromJSON,
    CreateUpdateAttachmentDtoFromJSONTyped,
    CreateUpdateAttachmentDtoToJSON,
} from './CreateUpdateAttachmentDto';

/**
 * 
 * @export
 * @interface CreateUpdateManualDto
 */
export interface CreateUpdateManualDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateManualDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateManualDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateManualDto
     */
    testsIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateManualDto
     */
    attachmentsToDelete?: Array<string> | null;
    /**
     * 
     * @type {Array<CreateUpdateAttachmentDto>}
     * @memberof CreateUpdateManualDto
     */
    attachments?: Array<CreateUpdateAttachmentDto> | null;
}

/**
 * Check if a given object implements the CreateUpdateManualDto interface.
 */
export function instanceOfCreateUpdateManualDto(value: object): value is CreateUpdateManualDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateUpdateManualDtoFromJSON(json: any): CreateUpdateManualDto {
    return CreateUpdateManualDtoFromJSONTyped(json, false);
}

export function CreateUpdateManualDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateManualDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'testsIds': json['testsIds'] == null ? undefined : json['testsIds'],
        'attachmentsToDelete': json['attachmentsToDelete'] == null ? undefined : json['attachmentsToDelete'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(CreateUpdateAttachmentDtoFromJSON)),
    };
}

export function CreateUpdateManualDtoToJSON(value?: CreateUpdateManualDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'testsIds': value['testsIds'],
        'attachmentsToDelete': value['attachmentsToDelete'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(CreateUpdateAttachmentDtoToJSON)),
    };
}

